// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperBrowserPreviewList-cls1_oNY","cls2":"PaperBrowserPreviewList-cls2_D0M PaperBrowserPreviewList-cls1_oNY"};